import { resetSessionExpiryFlag } from "@/utils/apiErrorHandler";
import { authService } from "./authServiceInstance";

let refreshPromise: Promise<void> | null = null;

/**
 * Ensures only one silent refresh happens at a time.
 * All callers await the same promise.
 */
export const refreshSession = async (): Promise<void> => {
  if (!refreshPromise) {
    refreshPromise = authService.UserManager.signinSilent()
      .then(() => {
        resetSessionExpiryFlag();
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  // eslint-disable-next-line @typescript-eslint/return-await
  return refreshPromise;
};
